import React, {createContext} from 'react';
import useAuth from './hooks/useAuth';

const Context = createContext();

function AuthProvider({children}) {
    const {
        handleLogin,
        utilizador,
        nome,
        acessos,
        rep,
        authenticated,
        oficina,
        handleRefresh,
        handleOficina,
        logout,
        handleLogout,
        path,
        setPath,
        catalogoCard,
        adicionarItemAoCarrinho,
        setCatalogoCard,
        isCard,
        openCards,
        setOpenCards,
        setIsCard,
        theme,
        setTheme,
        setCarrinhoItems,
        carrinhoItems,
        colorTheme,
        userRepresentante,
        verifAuthenticated,
        formatarNumero,
    } = useAuth();
    return (
        <Context.Provider
            value={{
                handleLogin,
                utilizador,
                nome,
                acessos,
                rep,
                authenticated,
                oficina,
                isCard,
                openCards,
                setOpenCards,
                catalogoCard,
                setCatalogoCard,
                setIsCard,
                adicionarItemAoCarrinho,
                handleRefresh,
                handleOficina,
                logout,
                handleLogout,
                path,
                setPath,
                setCarrinhoItems,
                carrinhoItems,
                theme,
                setTheme,
                colorTheme,
                userRepresentante,
                verifAuthenticated,
                formatarNumero,
            }}>
            {children}
        </Context.Provider>
    );
}

export {Context, AuthProvider};
